module.exports = __webpack_public_path__ + "@/assets/img/clock.9fa92a67.svg";